import { StorageService } from './../_services/storage.service';
import { Router } from '@angular/router';
import { Component, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { UtilityService } from '../_services/utility.service';
import { ProfileService } from '../_services/profile.service';

@Component({
  selector: 'app-secure',
  templateUrl: './secure.component.html',
  styleUrls: ['./secure.component.css']
})
export class SecureComponent implements OnInit {
  constructor(
    private readonly router: Router,
    private readonly storageService: StorageService,
    private readonly utilityService: UtilityService,
    private readonly title: Title,
    private readonly profileService: ProfileService
  ) {}

  ngOnInit(): void {
    this.profileService.getProfile().subscribe(userLogged => {
      if (!userLogged.result) {
        this.router.navigate(['/']);
      }
    });
  }
}
